module.exports = {"en":{"launcher":"Launcher:","version":"{server} version {version}","patchNotes":"Patch Notes"},"de":{"launcher":"Launcher:","version":"{server} Version {version}","patchNotes":"Patch-Details"},"fr":{"launcher":"Lanceur:","version":"{server} version {version}","patchNotes":"Notes de patch"},"ru":{"launcher":"Версия программы:","version":"{server} версия {version}","patchNotes":"Информация о патчах"},"ja":{"launcher":"Launcher:","version":"{server} version {version}"},"zh":{"launcher":"启动器：","version":"{server} {version}","patchNotes":"更新说明"}}


//////////////////
// WEBPACK FOOTER
// ./src/features/LoadingBar/localization/localized.json
// module id = 1125
// module chunks = 0